import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class SourceObjectFilterData {
    sourceObjects: Array<DropdownOptionIntegerId>;
    platforms: Array<DropdownOptionIntegerId>;
    dataSets: Array<DropdownOptionIntegerId>;
    dataOwners: Array<DropdownOptionIntegerId>;
}
